var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#B8C6CF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9998 30.5458C25.3507 30.5458 21.4896 26.7924 21.4896 22.3495C21.4896 17.7534 25.3507 14 29.9998 14C34.8065 14 38.51 17.7534 38.51 22.3495C38.51 26.7924 34.8065 30.5458 29.9998 30.5458ZM29.9998 18.8259C28.0299 18.8259 26.5327 20.4345 26.5327 22.3495C26.5327 24.2645 28.0299 25.7199 29.9998 25.7199C32.0485 25.7199 33.4669 24.2645 33.4669 22.3495C33.4669 20.4345 32.0485 18.8259 29.9998 18.8259ZM33.3882 37.3633L38.1948 41.8828C39.1404 42.8785 39.1404 44.334 38.1948 45.2532C37.1704 46.2489 35.5945 46.2489 34.8065 45.2532L29.9998 40.6572L25.3507 45.2532C24.8779 45.7128 24.2475 45.9425 23.5383 45.9425C22.9868 45.9425 22.3564 45.7128 21.8048 45.2532C20.8592 44.334 20.8592 42.8785 21.8048 41.8828L26.6902 37.3633C24.8779 36.8271 23.2232 36.1376 21.6472 35.2184C20.4652 34.6056 20.2288 33.0736 20.8592 31.9246C21.6472 30.7756 23.0656 30.4692 24.3263 31.2352C27.7935 33.3034 32.2061 33.3034 35.6732 31.2352C36.934 30.4692 38.4312 30.7756 39.1404 31.9246C39.8496 33.0736 39.5343 34.6056 38.4312 35.2184C36.934 36.1376 35.2005 36.8271 33.3882 37.3633Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/ok.8e8f186dd94464499ed09f6540f0c384.svg";
export { ForwardRef as ReactComponent };